import script from "./_job.vue?vue&type=script&setup=true&lang=js"
export * from "./_job.vue?vue&type=script&setup=true&lang=js"

import "./_job.vue?vue&type=style&index=0&id=cb841288&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb841288"]])

export default __exports__